import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SearchField from "../components/layouts/SearchField";
import Header from "../components/layouts/Header";
import InspectionCard from "../components/home/InspectionCard";
import InspectionDetail from "../components/home/InspectionDetail";
import SurveyorInfo from "../components/home/SurveyorInfo";
import InspectionList from "../components/home/InspectionList";
import { Icon } from "@iconify/react";
import InspectionModal from "../components/home/InspectionModal";
import { api } from "../services/api-service";
import { useDispatch, useSelector } from "react-redux";
import {
  addSurvey,
  getMySurveys,
  surveySelector,
  surveysSelector,
} from "../redux/surveySlice";
import { resetInspection } from "../redux/inspectionSlice";
import { userSelector } from "../redux/authSlice";
import Footer from "../components/layouts/Footer";
import NoSurvey from "./NoSurvey";
import InspectionDateFilter from "../components/layouts/InspectionDateFilter";
import { format } from "date-fns";

const Home = () => {
  const dispatch = useDispatch();
  const searchTimeout = useRef();
  const user = useSelector(userSelector);
  const survey = useSelector(surveySelector);
  const surveys = useSelector(surveysSelector);
  // const [surveys, setSurveys] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getSurveys();
    }, 500);
  }, [search]);

  const getSurveys = async (dateRange = {}) => {
    const nextStartDate =
      dateRange.startDate === undefined ? startDate : dateRange.startDate;
    const nextEndDate =
      dateRange.endDate === undefined ? endDate : dateRange.endDate;

    dispatch(
      getMySurveys({
        user,
        search,
        startDate: nextStartDate
          ? format(nextStartDate, "yyyy-MM-dd")
          : null,
        endDate: nextEndDate ? format(nextEndDate, "yyyy-MM-dd") : null,
      }),
    );
  };

  const applyDateFilter = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSurveys({ startDate: start, endDate: end });
  };

  const clearDateFilter = () => {
    setStartDate(null);
    setEndDate(null);
    getSurveys({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Boolean(search || startDate);

  return (
    <>
      <Header text={search} onChange={(e) => setSearch(e)} />
      <div className="main">
        <Container fluid>
          <Row>
            <Col lg="3">
              <div className="searchSurvey d-flex align-items-start">
                <div className="d-none d-md-block flex-grow-1">
                  <SearchField text={search} onChange={(e) => setSearch(e)} />
                </div>
                <InspectionDateFilter
                  startDate={startDate}
                  endDate={endDate}
                  onApply={applyDateFilter}
                  onClear={clearDateFilter}
                />
              </div>
              <div className="surveyListHeight">
                {!surveys.data?.length > 0 && (
                  <NoSurvey
                    type={
                      hasActiveFilters
                        ? "No survey found"
                        : "No surveys assigned yet!"
                    }
                    text={
                      hasActiveFilters
                        ? "Try adjusting or clearing your search and inspection date filters"
                        : "There are no surveys assigned to you at this moment. Please contact admin for any assistance"
                    }
                  />
                )}
                {surveys?.data?.map((desc, index) => (
                  <InspectionCard key={index} survey={desc} />
                ))}
              </div>
            </Col>
            <Col lg="6">
              <InspectionDetail />
            </Col>
            <Col lg="3">
              <div className="mb-lg-3 rightMainWrapper">
               <div className="d-none d-lg-block"> 
                  <SurveyorInfo />
                </div>
                {survey.id && <InspectionList showAdd={true} />}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Home;
